<template>
  <div>
    <div v-html="payGateWay"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      payGateWay: "",
      token: ""
    };
  },
  mounted() {
    this.payGateWay = this.$route.query.htmlData;
    this.$nextTick(() => {
      document.forms[0].submit();
    });
    // 监听主窗口传来的token
    window.addEventListener(
      "message",
      event => {
        if (event.origin !== window.location.origin) return;
        if (event.data && event.data.token) {
          this.token = event.data.token;
          sessionStorage.setItem("token", event.data.token);
        }
      },
      false
    );
  }
};
</script>
